/*
 * @Author: cc
 * @Date: 2020-12-30 09:34:48
 * @LastEditTime: 2021-10-27 17:11:59
 * @LastEditors: tanyaohua
 * @FilePath: \xjmediacloud\app\editingCenter\trill\trillLeft.js
 * @Description: 
 */
/**
 * Created by cc 19-10-25
 * 抖音渠道左侧模块
 */

angular.module('editTrillLeftModule', []).controller('EditTrillLeftCtrl', [
    '$scope',
    '$controller',
    '$element',
    'editingMediatype',
    function (
        $scope,
        $controller,
        $element,
        editingMediatype
    ) {
        initStatus();

        /**
         * [initStatus description]初始化状态
         *
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.trench = {
                params: {
                    MediaType: editingMediatype.trill,
                    PAGESIZE: 1000,
                    methodname: 'queryWebSitesByMediaType',
                    serviceid: 'mlf_mediasite',
                },
                router: 'trill',
                accountKey: 'DOUYINACCOUNTID', // 因为原有接口返回的跟现在不一致，需要一个标识区分主键ID
                mediaType: editingMediatype.trill,
            };
            $controller('EditShortVideoLeftCtrl', {$scope: $scope, $element: $element}); // 控制器继承
        }
    },
]);
